import { Activityresult, SearchWordResult, Trafficresult, AreaResult, VisibilityPotentialTable } from "models/StatisticsReport";
import { useState } from "react";

interface TableProps {
    data: Activityresult[] | Trafficresult[] | SearchWordResult[] | AreaResult[] | VisibilityPotentialTable[]
    columnName: string[]
    useSlice?: boolean
    limit?: number
    useButton?:boolean,
    highlightedWords?: string[]
}

const Table = ({data, columnName, useSlice = true, limit = 5, useButton = false, highlightedWords = []}:TableProps) => {
    const [showAll, setShowAll] = useState(false);
    const handleReadMore = () => {
        setShowAll(true);
    }

    const handleHide = () => {
        setShowAll(false);
    }
    if(!data || data.length === 0) {
        return <div className="mb-0"><p>Ingen aktivitet</p></div>
    }
    
    const rowToShow = !useSlice || showAll ? data : data.slice(0,limit);

    const handleLinkClick = () => {
        const link = document.getElementById("clickStatTraffic");
        link?.scrollIntoView({behavior: 'smooth'});
        link?.classList.add('cc-click-stat-traffic-show');
    }

    const handleHighlightedWords = (str:string) => {
        if(highlightedWords.includes(str)) {
            return <strong>{str}</strong>;
        }
        return str;
    }

    const handleIsVisible = (data:Activityresult | Trafficresult | SearchWordResult | AreaResult | VisibilityPotentialTable) => {
        if('isVisible' in data) {
            if(data.isVisible) {
                return <i className="bi bi-eye text-secondary text-success me-1"></i>
            }
            return <i className="bi bi-eye-slash cc-color-orange me-1"></i>;
        }
        return <></>;
    }

    const handleTextMutedColor = (data:Activityresult | Trafficresult | SearchWordResult | AreaResult | VisibilityPotentialTable) => {
        if('isVisible' in data) {
            if(!data.isVisible) {
                return "text-muted ";
            }
        }
        return "";
    }

    const validNames = ["til hjemmeside", "klikk til din bedrifts hjemmeside"];

    return (
        <>
            <table className="table cc-striped-table cc-table-number-cols">
                <tbody>
                    <tr>
                        {columnName.map((element) => {
                            return (
                                <td key={element}>{element}</td>
                            )
                        })}
                    </tr>
                    {rowToShow.map((element) => {
                        return (<tr key={element.name}>
                            <td className={handleTextMutedColor(element) + "text-break"}>{handleIsVisible(element)}{validNames.includes(element.name.toLocaleLowerCase()) ? (
                                <button type="button" className="btn btn-link p-0 m-0 align-baseline text-decoration-none" onClick={handleLinkClick}>{handleHighlightedWords(element.name)}</button>
                            ) : (handleHighlightedWords(element.name))}</td>
                            {'count' in element && <td className={handleTextMutedColor(element)}>{new Intl.NumberFormat('nb-NO').format(element.count)}</td>}
                            {'value' in element && <td className={handleTextMutedColor(element)}>{new Intl.NumberFormat('nb-NO').format(element.value)}</td>}
                            {'percentage' in element && <td>{element.percentage}%</td>}
                        </tr>)
                    })}
                </tbody>
            </table>
            {useSlice && ( !showAll ? 
                    useButton ? (
                        <button type="button" className="btn btn-primary btn-sm" onClick={handleReadMore}>Vis alle</button>
                    ) : (
                        <p className="mb-0 mt-2" ><span className="link-primary" onClick={handleReadMore}>Vis alle</span></p>
                    )
                 : (
                    useButton ? (
                        <button type="button" className="btn btn-primary btn-sm" onClick={handleHide}>Vis færre</button>
                    ) : (
                        <p className="mb-0 mt-2" ><span className="link-primary" onClick={handleHide}>Vis færre</span></p>
                    )
                )
            )}
        </>
    );
}

export default Table;